import { Loader2, Check, CloudOff } from "lucide-react";

// Small "Saving / Saved / Offline – awaiting sync" status text — used next to
// the Save button on the report runner and next to the Submit button on
// public site forms so work-in-progress is never a silent black box.
const CONFIG = {
    saving: { icon: Loader2, spin: true, label: "Saving…", cls: "text-[#9A968F]" },
    saved: { icon: Check, spin: false, label: "Saved", cls: "text-[#3F7D3A]" },
    offline: { icon: CloudOff, spin: false, label: "Offline – awaiting sync", cls: "text-[#9F4212]" },
    error: { icon: CloudOff, spin: false, label: "Save failed – will retry", cls: "text-[#B33A2E]" },
};

export function SyncStatusIndicator({ status, testId = "sync-status" }) {
    const c = CONFIG[status] || CONFIG.saved;
    const Icon = c.icon;
    return (
        <span data-testid={testId} data-sync-status={status}
            className={`text-[11px] font-semibold flex items-center gap-1 ${c.cls}`}>
            <Icon className={c.spin ? "animate-spin" : ""} size={12} />
            {c.label}
        </span>
    );
}
